<template>
    <div
        :id="mid"
        class="map"
    >
    </div>
</template>

<script>
export default {
    name: "main_map",
    props: {},
    data() {
        return {
            mid: "",
            map: "",
        };
    },
    created() {
        this.mid = this.mapId();
    },
    mounted() {
        this.initMap();
    },
    methods: {
        mapId() {
            return "map-xxxx-xxxx-xxxx-xxxx".replace(/[xy]/g, function (c) {
                var r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },
        initMap() {
            this.map = new AMap.Map(this.mid, {
                zoom: 6, //初始地图级别
                center: [113.241402, 23.096626], //初始地图中心点
                showIndoorMap: false, //关闭室内地图
            });

            //为地图注册click事件获取鼠标点击出的经纬度坐标
            // this.map.on("click", function (e) {
            //     console.log(e.lnglat.getLng() + "," + e.lnglat.getLat());
            // });

            //添加主要标记
            // let Marker1 = new AMap.Marker({
            //     position: [113.241402, 23.096626],
            //     // label: {
            //     //     content: "test",
            //     //     offset: new AMap.Pixel(20, 20),
            //     // },
            // });

            // this.map.add([Marker1]);
        },
        addMaker(makerList) {
            makerList.forEach((item) => {
                if (item.lon && item.Lat) {
                    let Marker = new AMap.Marker({
                        position: [item.lon, item.Lat],
                        label: {
                            content: item.PrjName,
                            offset: new AMap.Pixel(20, 20),
                        },
                    });
                    this.map.add(Marker);
                }
            });
        },
        setMapCenter(lng, lat, name) {
            this.map.clearMap();
            this.map.setCenter([lng, lat]);
            this.map.setZoom(18); //设置地图层级
            //添加主要标记
            let Marker1 = new AMap.Marker({
                position: [lng, lat],
                label: {
                    content: name,
                    offset: new AMap.Pixel(20, 20),
                },
            });
            this.map.add([Marker1]);
        },
    },
    computed: {},
    watch: {},
};
</script>

<style lang="scss">
.map {
    width: 100%;
    height: 100%;
    .amap-logo {
        display: none;
        opacity: 0 !important;
    }
    .amap-copyright {
        opacity: 0;
    }
}
</style>

